import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import axios from 'axios';
import ActionTable from '../common/Table';
import Layout from '../common/Layout';
import { CommonConfig } from '../../../config/common-config';
// import VisibilityIcon from '@material-ui/icons/Visibility';
// import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
}));

const UltimateInvoiceView = (props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setRows] = useState([]);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const headcells = [
        { id: 'invoiceNumber', label: 'Invoice Number' },
        { id: 'invoiceDate', label: 'Invoice date' },
        { id: 'description', label: 'Description' },
        { id: 'servicetype', label: 'Service Type' },
        { id: 'totalAmount', label: 'Amount' },
        { id: 'isPaid', label: 'Status' },
    ];

    // At the time of Component mounts
    const history = useHistory();
    useEffect(() => {
        const userData = JSON.parse(sessionStorage.getItem('user'));
        const buyerEmail = userData.result.data.userName;
        const buyerType = userData.result.data.userType;
        const imc = JSON.parse(userData.result.config.data).tennantName;

        const postData = {
            "buyerType": buyerType,
            "buyerEmail": buyerEmail
        };

        //console.log("data", postData);
        axios.post(`${CommonConfig.dev.baseUrl}/api/auth/admininvoices/list/${imc}`, postData , axiosConfig).then((res) => {
            //console.log(res.data);
            setRows(res.data.content);
        });
    }, [userToken]);

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    // handle search item  
    const handleSearchQuery = (data) => {
        //console.log(data);
        setSearchQuery(data);
        // filterData(data);
    };

    const classes = useStyles();

    // filtered row based on search

    const filteredRow = searchQuery
        ? rows.filter((row) => {
            const query = searchQuery.toLowerCase().trim();
            return headcells
                .map((col) => col.id)
                .some((key) => {
                    return row[key].toString().toLowerCase().includes(query);
                });
        })
        : rows;

    return (
        <div className={classes.root}>
            <Layout title="Invoice" searchQuery={searchQuery} onChange={handleSearchQuery} className={classes}>
                {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '700' }}>No records found to display!</span>}
                <ActionTable headcells={headcells} rows={filteredRow} action post="ultimate" mode="view" />
            </Layout>
        </div>
    );
};

export default UltimateInvoiceView;
